import { UserRoles } from 'enums';
import { DetailPage } from 'pages/Accounts/Detail/enums';

export enum ArrayCheck {
  ANY = 'ANY',
  ALL = 'ALL',
}

export interface RequiredPermissions {
  roles?: UserRoles[];
  rolesCheck?: ArrayCheck;
}

export enum Permission {
  APP_ADVISOR = 'APP_ADVISOR',
  APP_ENDUSER = 'APP_ENDUSER',

  ACCESS_ADVISOR = 'ACCESS_ADVISOR',
  ACCESS_BASIC = 'ACCESS_BASIC',
  ACCESS_ADMIN = 'ACCESS_ADMIN',
  ACCESS_BACKOFFICE = 'ACCESS_BACKOFFICE',
  ACCESS_USER_SIGNING = 'ACCESS_USER_SIGNING',
  ACCESS_USER_BASIC = 'ACCESS_USER_BASIC',
  ACCESS_USER_FULL = 'ACCESS_USER_FULL',

  PAGE_DETAIL = 'PAGE_DETAIL',

  ACCOUNT_CREATE_NEW = 'ACCOUNT_CREATE_NEW',
  ACCOUNT_CREATE_MOCK = 'ACCOUNT_CREATE_MOCK',
  ACCOUNT_CREATE_LEGAL = 'ACCOUNT_CREATE_LEGAL',
  ACCOUNT_CREATE_PHYSICAL = 'ACCOUNT_CREATE_PHYSICAL',
  ACCOUNT_REQUEST_SIGN = 'ACCOUNT_REQUEST_SIGN',
  ACCOUNT_DRAFT_REMOVE = 'ACCOUNT_DRAFT_REMOVE',
  ACCOUNT_REBALANCING = 'ACCOUNT_REBALANCING',
  ACCOUNT_HEDGING = 'ACCOUNT_HEDGING',
  ACCOUNT_IND_PORTFOLIO = 'ACCOUNT_IND_PORTFOLIO',
  ACCOUNT_CURRENCY_EUR = 'ACCOUNT_CURRENCY_EUR',
  ACCOUNT_EXT_PRODUCT = 'ACCOUNT_EXT_PRODUCT',

  ACCOUNT_SET_CLIENTVIEW = 'ACCOUNT_CLIENTVIEW'

}

type Permissions = {
  [key in Permission]: RequiredPermissions | { [key: string]: RequiredPermissions };
};

export const permissions: Permissions = {
  [Permission.APP_ADVISOR]: {
    roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
  },
  [Permission.APP_ENDUSER]: {
    roles: [UserRoles.USER_BASIC, UserRoles.USER_SIGN, UserRoles.USER_FULL],
  },
  [Permission.ACCESS_ADVISOR]: {
    roles: [UserRoles.ADVISOR],
  },
  [Permission.ACCESS_BASIC]: {
    roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
  },
  [Permission.ACCESS_ADMIN]: {
    roles: [UserRoles.EDW_ADMIN],
  },
  [Permission.ACCESS_BACKOFFICE]: {
    roles: [UserRoles.EDW_BACKOFFICE],
  },
  [Permission.ACCESS_USER_SIGNING]: {
    roles: [UserRoles.USER_SIGN],
  },
  [Permission.ACCESS_USER_BASIC]: {
    roles: [UserRoles.USER_BASIC],
  },
  [Permission.ACCESS_USER_FULL]: {
    roles: [UserRoles.USER_FULL],
  },
  [Permission.ACCOUNT_CREATE_NEW]: {
    roles: [UserRoles.ACCOUNT_CREATE_NEW],
  },
  [Permission.ACCOUNT_CREATE_MOCK]: {
    roles: [UserRoles.ADVISOR, UserRoles.EDW_ADMIN],
  },
  [Permission.ACCOUNT_CREATE_LEGAL]: {
    roles: [UserRoles.ACCOUNT_CREATE_LEGAL],
  },
  [Permission.ACCOUNT_CREATE_PHYSICAL]: {
    roles: [UserRoles.ACCOUNT_CREATE_PHYSICAL],
  },
  [Permission.ACCOUNT_REQUEST_SIGN]: {
    roles: [UserRoles.ACCOUNT_REQUEST_SIGN],
  },
  [Permission.ACCOUNT_DRAFT_REMOVE]: {
    roles: [UserRoles.ACCOUNT_DRAFT_REMOVE],
  },
  [Permission.ACCOUNT_REBALANCING]: {
    roles: [UserRoles.ACCOUNT_REBALANCING],
  },
  [Permission.ACCOUNT_HEDGING]: {
    roles: [UserRoles.ACCOUNT_HEDGING],
  },
  [Permission.ACCOUNT_SET_CLIENTVIEW]: {
    roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
  },
  [Permission.ACCOUNT_IND_PORTFOLIO]: {
    roles: [UserRoles.ACCOUNT_IND_PORTFOLIO],
  },
  [Permission.ACCOUNT_CURRENCY_EUR]: {
    roles: [UserRoles.ACCOUNT_CURRENCY_EUR],
  },
  [Permission.ACCOUNT_EXT_PRODUCT]: {
    roles: [UserRoles.ACCOUNT_EXT_PRODUCT],
  },


  [Permission.PAGE_DETAIL]: {
    [DetailPage.DASHBOARD]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE, UserRoles.USER_FULL],
    },
    [DetailPage.HISTORY]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE, UserRoles.USER_FULL],
    },
    [DetailPage.REPORTS]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE, UserRoles.USER_BASIC],
    },
    [DetailPage.ID]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE, UserRoles.USER_FULL],
    },
    [DetailPage.PLAN]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE, UserRoles.USER_FULL],
    },
    [DetailPage.SIGNED_DOCUMENTS]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE, UserRoles.USER_BASIC],
    },
    [DetailPage.SIGNATURE]: {
      roles: [UserRoles.USER_SIGN],
    },
    [DetailPage.FEES]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.SINGLE_FEES]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.MOVEMENTS]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.WITHDRAW]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.TRANSFER]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    /*
    [DetailPage.CLOSE_ACCOUNT]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    */
    [DetailPage.PROFILE]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.PERSONAL_DATA]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.ADVISOR_INFO]: {
      roles: [UserRoles.USER_SIGN, UserRoles.USER_BASIC, UserRoles.USER_FULL],
    },
    [DetailPage.DEPOSIT]: {
      roles: [UserRoles.USER_BASIC, UserRoles.USER_FULL, UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
    [DetailPage.CLIENT_VIEW]: {
      roles: [UserRoles.ADVISOR, UserRoles.EDW_BACKOFFICE],
    },
  },
};
